<template>
  <Modal
    :value="value"
    width="1000"
    :footer-hide="true"
    :closable="false"
    @on-cancel="closeModal"
    class-name="x-modal">
    <img src="@/assets/border-img-t-l.png" alt="" class="border-img border-top-left">
    <img src="@/assets/border-img-t-r.png" alt="" class="border-img border-top-right">
    <img src="@/assets/border-img-b-l.png" alt="" class="border-img border-bottom-left">
    <img src="@/assets/border-img-b-r.png" alt="" class="border-img border-bottom-right">
    <x-title title="购票须知"></x-title>
    <div class="need-know-content">{{content}}</div>
    <div class="close-wrap">
      <Button type="primary" class="close-btn" @click="closeModal">关闭</Button>
    </div>
  </Modal>
</template>

<script>
  import xTitle from '@/components/xTitle/index'
  export default {
    name: 'x-modal',
    props: ['value', 'content'],
    components: {
      'x-title': xTitle
    },
    data () {
      return {

      }
    },
    watch: {
      value: {
        deep: true,
        handler(newVal, oldVal) {
          if (newVal) {
            const dom = document.querySelector('.need-know-content')
            dom.innerHTML = this.content
          }
        }
      }
    },
    methods: {
      closeModal() {
        this.$emit('toClose', false)
      }
    }
  }
</script>

<style scoped>
  .border-img{
    position: absolute;
  }
  .bg-top-left{
    top: 20px;
    left: 20px;
  }
  .bg-top-right{
    top: 20px;
    right: 20px;
    transform: rotateZ(90deg);
  }
  .bg-bottom-left{
    bottom: 20px;
    left: 20px;
    transform: rotateZ(-90deg);
  }
  .bg-bottom-right{
    bottom: 20px;
    right: 20px;
    transform: rotateZ(180deg);
  }

  .need-know-title{
    text-align: center;
  }

  .need-know-content{
    padding: 40px 120px;
  }

  .need-know-title{
    padding-top: 20px;
  }

  .border-title{
    display: inline-block;
    line-height: 1;
    border-bottom: solid #9B3B32 3px;
  }

  .close-wrap{
    padding-bottom: 20px;
    text-align: center;
  }

  .close-btn{
    padding: 0 20px;
  }
</style>
<style>
  .x-modal .ivu-modal-body{
    padding: 30px;
  }
  /*.x-modal .ivu-modal-content{*/
  /*  background: url("../../assets/leaf.png") fixed center 240px no-repeat;*/
  /*  overflow-y: auto;*/
  /*}*/


  /* 滚动条样式修改 */
  /* 纵向滚动条和横向滚动条宽度 */
  /*.x-modal .ivu-modal::-webkit-scrollbar {*/
  /*  width: 10px;*/
  /*  height: 5px;*/
  /*  margin: 10px;*/
  /*}*/
  /* 滚动条按钮样式 */
  /*.x-modal .ivu-modal::-webkit-scrollbar-thumb {*/
  /*  border-radius: 10px;*/
  /*  background: #D8D8D8;*/
  /*}*/
  /* 滚动条背景条样式 */
  /*.x-modal .ivu-modal::-webkit-scrollbar-track {*/
  /*  border-radius: 10px;*/
  /*  background: #F7F7F7;*/
  /*}*/
</style>
